// The languages the aligner offers (decision 3): Interplae's 13 source languages, which are
// English and the languages interplae-segment has SRX rules for, and as targets Thai and the
// same 13. A Thai target is cut at its spaces; every other language by its sentences.

export const SOURCE_LANGUAGES: readonly (readonly [string, string])[] = [
  ['en', 'English'],
  ['ca', 'Catalan'],
  ['cs', 'Czech'],
  ['nl', 'Dutch'],
  ['fi', 'Finnish'],
  ['fr', 'French'],
  ['de', 'German'],
  ['it', 'Italian'],
  ['pl', 'Polish'],
  ['ru', 'Russian'],
  ['sk', 'Slovak'],
  ['es', 'Spanish'],
  ['sv', 'Swedish'],
]

export const TARGET_LANGUAGES: readonly (readonly [string, string])[] = [['th', 'Thai'], ...SOURCE_LANGUAGES]

/// A language's name, or its tag if it is not one of the list (a TMX may carry any tag).
export function languageName(tag: string): string {
  const primary = tag.split(/[-_]/)[0]?.toLowerCase() ?? tag
  return TARGET_LANGUAGES.find(([t]) => t === primary)?.[1] ?? tag
}
